// extracted by mini-css-extract-plugin
export default {"banner":"OfflineBanner_banner__5qduy","slideDown":"OfflineBanner_slideDown__qv2o4","offline":"OfflineBanner_offline__7f9hY","online":"OfflineBanner_online__GmpXi"};